import React, { useState, useEffect } from "react";
import {
  Table,
  Th,
  Td,
  DataStatus,
  TdFixed,
  // InputQtyDecimal,
  ThFixed,
  Tr,
  THead,
  TBody,
  ActionButton,
  SelectSearch,
  CreateButton,
  UpdateButton,
  DeleteButton,
  // NumberFormat,
} from "components";
import { useLocation } from "react-router-dom";
import { Formik, useFormikContext } from "formik";

import { SubKegiatanApi } from "api";
import * as Yup from "yup";
import { ButtonGroup } from "react-bootstrap";
import { AiOutlineCheck, AiOutlineClose } from "react-icons/ai";
import { DecimalConvert, RupiahConvert } from "utilities";

export const TableItemMaterialManusiaSection = ({
  dropdownItem,
  dropdownPengadaan,
  type,
  tabType,
  withPPA,
  data,
}) => {
  const [update, setUpdate] = useState("");
  const { values, setValues } = useFormikContext();
  const checkKeyTab =
    tabType === "material" ? "detailMaterial" : "detailManusia";

  const TableForm = ({ data }) => {
    const tableFormIntialValues = {
      idKategori: data?.idKategori ?? null,
      namaKategori: data?.namaKategori ?? null,
      idItemSumberDaya: data?.idItemSumberDaya ?? null,
      namaItemSumberDaya: data?.namaItemSumberDaya ?? null,
      namaSatuan: data?.namaSatuan ?? null,
      idSatuan: data?.idSatuan ?? null,
      qty: parseFloat(data?.qty ?? 0),
      idSumberPengadaan: data?.idSumberPengadaan ?? null,
      namaSumberPengadaan: data?.namaSumberPengadaan ?? null,
      hargaSatuan: parseFloat(data?.hargaSatuan ?? 0),
    };
    const tableValidationSchema = Yup.object().shape({
      qty: Yup.string().required("Masukan qty").nullable(),
      idItemSumberDaya: Yup.string()
        .required("Pilih item sumber daya")
        .nullable(),
      idSumberPengadaan: Yup.string()
        .required("Pilih item sumber pengadaan")
        .nullable(),
      hargaSatuan: Yup.string().required("Masukan harga satuan").nullable(),
    });

    const setSubmitHandler = (value, key) => {
      if (data) {
        setValues({
          ...values,
          subKegiatan: {
            ...values.subKegiatan,
            [key]: values?.subKegiatan?.[key].map((val, index) =>
              update === index ? value : val
            ),
          },
        });
        setUpdate(undefined);
      }
      if (!data) {
        setValues({
          ...values,
          subKegiatan: {
            ...values?.subKegiatan,
            [key]: [value, ...values?.subKegiatan?.[key]],
          },
        });
      }
    };
    const tableSubmitHandler = (value) => {
      tabType === "material" && setSubmitHandler(value, "detailMaterial");
      tabType === "manusia" && setSubmitHandler(value, "detailManusia");
    };

    console.log(values);

    return (
      <Formik
        enableReinitialize
        initialValues={tableFormIntialValues}
        validationSchema={tableValidationSchema}
        onSubmit={tableSubmitHandler}
      >
        {({ values, setValues, errors, touched, handleSubmit }) => (
          <Tr>
            <Td colSpan="2">
              <SelectSearch
                placeholder="Pilih item material"
                option={dropdownItem}
                defaultValue={{
                  value: values.idItemSumberDaya ?? "",
                  label: values.namaItemSumberDaya ?? "Pilih item material",
                }}
                onChange={(val) => {
                  setValues({
                    ...values,
                    idItemSumberDaya: val.value,
                    namaItemSumberDaya: val.label,
                    namaSatuan: val.namaSatuan,
                  });
                }}
                error={
                  Boolean(errors.idItemSumberDaya) && touched.idItemSumberDaya
                }
                errorText={
                  Boolean(errors.idItemSumberDaya) &&
                  touched.idItemSumberDaya &&
                  errors.idItemSumberDaya
                }
              />
            </Td>
            <Td>{values?.namaSatuan ?? "-"}</Td>
            <Td>
              <SelectSearch
                placeholder="Pilih sumber pengadaan"
                option={dropdownPengadaan}
                defaultValue={{
                  value: values.idSumberPengadaan ?? "",
                  label: values.namaSumberPengadaan ?? "Pilih sumber pengadaan",
                }}
                onChange={(val) => {
                  setValues({
                    ...values,
                    idSumberPengadaan: val.value,
                    namaSumberPengadaan: val.label,
                  });
                }}
                error={
                  Boolean(errors.idSumberPengadaan) && touched.idSumberPengadaan
                }
                errorText={
                  Boolean(errors.idSumberPengadaan) &&
                  touched.idSumberPengadaan &&
                  errors.idSumberPengadaan
                }
              />
            </Td>
            <Td>
              {/* <InputQtyDecimal
                placeholder="Masukan qty"
                value={values?.qty ?? null}
                onChange={(e) => setValues({ ...values, qty: e })}
                error={Boolean(errors.qty) && touched.qty}
                errorText={Boolean(errors.qty) && touched.qty && errors.qty}
              /> */}
            </Td>
            <Td>
              {/* <NumberFormat
                placeholder="Masukan harga satuan"
                value={values?.hargaSatuan}
                decimalSeparator=","
                onChange={(e) => setValues({ ...values, hargaSatuan: e })}
                error={Boolean(errors.hargaSatuan) && touched.hargaSatuan}
                errorText={
                  Boolean(errors.hargaSatuan) &&
                  touched.hargaSatuan &&
                  errors.hargaSatuan
                }
              /> */}
            </Td>
            <Td>
              {
                RupiahConvert(
                  String(
                    parseFloat(values.hargaSatuan ?? 0) *
                      parseFloat(values.qty ?? 0)
                  )
                ).getWithComa
              }
            </Td>
            <TdFixed>
              {data ? (
                <>
                  <ButtonGroup>
                    <ActionButton
                      text={<AiOutlineCheck />}
                      variant="success"
                      onClick={handleSubmit}
                      size="sm"
                    />
                    <ActionButton
                      text={<AiOutlineClose />}
                      variant="danger"
                      onClick={() => setUpdate(undefined)}
                      size="sm"
                    />
                  </ButtonGroup>
                </>
              ) : (
                <CreateButton
                  noText
                  icon
                  className="px-4"
                  onClick={handleSubmit}
                  size="sm"
                />
              )}
            </TdFixed>
          </Tr>
        )}
      </Formik>
    );
  };

  return (
    <>
      <Table>
        <THead>
          <Tr>
            <Th>No</Th>
            <Th style={{ textTransform: "capitalize" }}>Item {tabType}</Th>
            <Th>Satuan</Th>
            <Th>Sumber Pengadaan</Th>
            <Th>Qty.</Th>
            <Th>Harga Satuan</Th>
            {withPPA && <Th>Harga Satuan PPA</Th>}
            <Th>Sub Total</Th>
            {/* {type !== "read" && <ThFixed>Aksi</ThFixed>} */}
          </Tr>
        </THead>
        <TBody>
          {/* {type !== "read" && <TableForm />} */}
          {data.length > 0 ? (
            data.map((val, index) =>
              update === index ? (
                <TableForm data={val} />
              ) : (
                <Tr key={index}>
                  <TdFixed>{index + 1}</TdFixed>
                  <Td>{val.namaItemSumberDaya ?? "-"}</Td>
                  <Td>{val.namaSatuan ?? "-"}</Td>
                  <Td>{val.namaSumberPengadaan ?? "-"}</Td>
                  <Td className="text-right">
                    {DecimalConvert(parseFloat(val.qty ?? 0)).getWithComa}
                  </Td>

                  <Td className="text-right">
                    {
                      RupiahConvert(
                        parseFloat(val?.hargaSatuanPPA ?? 0).toString()
                      ).getWithComa
                    }
                  </Td>

                  <Td className="text-right">
                    {
                      RupiahConvert(
                        String(
                          parseFloat(val.hargaSatuanPPA ?? 0) *
                            parseFloat(val.qty ?? 0)
                        )
                      ).getWithComa
                    }
                  </Td>

                  {/* {type !== "read" && (
                    <TdFixed>
                      <ButtonGroup>
                        <UpdateButton
                          noText
                          icon
                          variant="success"
                          onClick={() => setUpdate(index)}
                          size="sm"
                        />
                        <DeleteButton
                          noText
                          icon
                          onClick={() => {
                            const filterData = values.subKegiatan?.[
                              checkKeyTab
                            ]?.filter((res, ind) => ind !== index);

                            setValues({
                              ...values,
                              subKegiatan: {
                                ...values?.subKegiatan,
                                [checkKeyTab]: filterData,
                              },
                            });
                          }}
                          size="sm"
                        />
                      </ButtonGroup>
                    </TdFixed>
                  )} */}
                </Tr>
              )
            )
          ) : (
            <tr>
              <td colSpan={10}>
                <DataStatus text="Tidak ada data" />
              </td>
            </tr>
          )}
        </TBody>
      </Table>
    </>
  );
};
